import { useFirebase } from 'react-redux-firebase'
import { useSelector, useDispatch } from 'react-redux'
import { getProfileForm } from '../selectors'
import { createProfileError } from '../commands/profile/create'
import { actions as appActions } from '../../App/reducer'
import React from 'react'
import { updateProfileError } from '../commands/profile/update'

export const useUpdateFirebase = ({
  isFormValid,
}: {
  isFormValid: boolean
}) => {
  const dispatch = useDispatch()
  const firebase = useFirebase()

  const profileForm = useSelector(getProfileForm)
  const profileCreateError = useSelector(createProfileError)
  const profileUpdateError = useSelector(updateProfileError)

  const onError = React.useCallback(
    (message: string) => {
      dispatch(
        appActions.onAlert({
          severity: 'error',
          message,
        })
      )
    },
    [dispatch]
  )

  React.useEffect(() => {
    if (profileCreateError || profileUpdateError) {
      onError('Failed to create profile')
      return
    }
    const currentUser = firebase.auth().currentUser
    const updateFirebase = async () => {
      if (currentUser != null) {
        await currentUser
          .updateEmail(profileForm.email)
          .catch(() => onError('Error updating email'))
      }
    }
    if (isFormValid) updateFirebase()
  }, [
    profileForm,
    firebase,
    onError,
    profileCreateError,
    profileUpdateError,
    isFormValid,
  ])
}
